import type { ProductKeys3P } from '@atlassian/rovo-connectors-config/types';

import { is3pProductKey, type ProductKeys } from '../../../../../common/constants/product-keys';
import { type ThirdPartyConfigsBootstrap } from '../../../../../common/constants/schemas/3p-config';
import { hasAdminImportedUserLink } from '../../../../../common/utils/connectors';
import { isImpersonationEnabled } from '../../../../../common/utils/filters';

export const isProductEntitiesIncluded: (
	availableProducts: ProductKeys[],
	product: ProductKeys,
	thirdPartyConfigs: ThirdPartyConfigsBootstrap,
) => boolean = (
	availableProducts: ProductKeys[],
	product: ProductKeys,
	thirdPartyConfigs: ThirdPartyConfigsBootstrap,
): boolean => {
	if (is3pProductKey(product)) {
		return (
			availableProducts.includes(product) &&
			(!thirdPartyConfigs[product as ProductKeys3P]?.userNeedsOAuth ||
				isImpersonationEnabled(product, thirdPartyConfigs) ||
				hasAdminImportedUserLink(product, thirdPartyConfigs))
		);
	} else {
		return availableProducts.includes(product);
	}
};
